import { render, staticRenderFns } from "./tooltipCommon.vue?vue&type=template&id=23f7eb38"
import script from "./tooltipCommon.vue?vue&type=script&lang=js"
export * from "./tooltipCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports